module.exports = __webpack_public_path__ + "static/media/img_fenlei17.459fb9e3.png";